/** Shared HTML table numeric column filters for P&L by Program reports */

import React from "react";
import { NumericFilterContent, TextFilterContent } from "../waterfall-eac/tableColumnFilterShared";

export const OP_LABELS = { gt: ">", gte: "≥", lt: "<", lte: "≤", eq: "=", neq: "≠" };

export const OP_ENTRIES = [
  { key: "gt",  label: "> Greater than"          },
  { key: "gte", label: "≥ Greater than or equal" },
  { key: "lt",  label: "< Less than"             },
  { key: "lte", label: "≤ Less than or equal"    },
  { key: "eq",  label: "= Equals"                },
  { key: "neq", label: "≠ Not equal"             },
];

import {
  calcPanelLeft,
  OP_DROPDOWN_WIDTH,
  OP_DROPDOWN_EST_HEIGHT,
} from "../waterfall-eac/filterPopoverUtils";

export { OP_DROPDOWN_WIDTH, OP_DROPDOWN_EST_HEIGHT };

/** Fixed operator dropdown — opens above the trigger when clipped below the viewport */
export function calcOpDropdownPos(btn, dropdownHeight = OP_DROPDOWN_EST_HEIGHT) {
  const r = btn.getBoundingClientRect();
  const left = calcPanelLeft(r, OP_DROPDOWN_WIDTH);
  const gap = 4;
  const belowTop = r.bottom + gap;
  const aboveTop = r.top - gap - dropdownHeight;
  const spaceBelow = window.innerHeight - belowTop;
  const spaceAbove = r.top - gap;
  const openBelow = spaceBelow >= dropdownHeight || spaceBelow >= spaceAbove;
  return { top: openBelow ? belowTop : Math.max(4, aboveTop), left };
}

const EQ_EPS = 0.5;

function parseFilterValue(v) {
  return parseFloat(String(v).replace(/,/g, ""));
}

export function isNumFilterActive(filter) {
  if (!filter || filter.value === "" || filter.value == null) return false;
  return !Number.isNaN(parseFilterValue(filter.value));
}

export function applyNumFilter(rawVal, filter) {
  if (!isNumFilterActive(filter)) return true;
  const threshold = parseFilterValue(filter.value);
  if (Number.isNaN(threshold)) return true;
  const v = rawVal == null || rawVal === "" ? 0 : Number(rawVal);
  if (Number.isNaN(v)) return false;
  switch (filter.op || "gt") {
    case "gt":  return v > threshold;
    case "gte": return v >= threshold;
    case "lt":  return v < threshold;
    case "lte": return v <= threshold;
    case "eq":  return Math.abs(v - threshold) < EQ_EPS;
    case "neq": return Math.abs(v - threshold) >= EQ_EPS;
    default:    return true;
  }
}

export function renderStandardNumFilter({
  label,
  colKey,
  colFilters,
  updateColFilter,
  clearColFilter,
  toggleOpDropdown,
  opBtnRefs,
}) {
  const f = colFilters[colKey] || { op: "gt", value: "" };
  return (
    <NumericFilterContent
      label={label}
      value={f.value ?? ""}
      op={f.op || "gt"}
      onValueChange={(v) => updateColFilter(colKey, "value", v)}
      onClear={() => clearColFilter(colKey)}
      onToggleOp={() => toggleOpDropdown(colKey)}
      opBtnRef={(el) => { opBtnRefs.current[colKey] = el; }}
    />
  );
}

export function renderStandardTextFilter({ label, value, onChange, onClear, placeholder }) {
  return (
    <TextFilterContent
      label={label}
      value={value}
      onChange={onChange}
      onClear={onClear}
      placeholder={placeholder}
    />
  );
}
